import React, { FC, useState } from "react";
import cn from "clsx";
import { NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useTranslation } from "react-i18next";
import ProductDeliveryInfo from "../../product/productDeliveryInfo";
import DynamicBannersWrapper from "../../dynamic/dynamicBanner";
import useDeliveryOptionsInfo from "../../../routes/pdp/hooks/useDeliveryOptionsInfo";
import useSectionsData from "../../../hooks/useSectionsData";
import {
  SECTION_TABS_INLINE_CONTENT_SLUGS,
  SECTION_TABS_MODULE_TYPE
} from "../../../constants/sections";
import DeliveredTo from "../deliveredTo";

const ACTIVE_TAB = {
  DELIVERY: "delivery",
  RETURNS: "returns"
} as const;

type ACTIVE_TAB_TYPE = ValueOf<typeof ACTIVE_TAB>;

type Props = {
  setModalState: React.Dispatch<React.SetStateAction<boolean>>;
};

const DeliveryReturnMobileModal: FC<Props> = ({ setModalState }) => {
  const { t } = useTranslation("productDetails");
  const deliveryInfo = useDeliveryOptionsInfo();
  const { data: returnsInfo } = useSectionsData(
    SECTION_TABS_MODULE_TYPE,
    SECTION_TABS_INLINE_CONTENT_SLUGS.RETURNS_AND_CANCELLATION
  );
  const [activeTab, setActiveTab] = useState<ACTIVE_TAB_TYPE>(
    ACTIVE_TAB.DELIVERY
  );

  const cityLabel = deliveryInfo[0]?.stateName || "";

  const toggleTab = (tab: ACTIVE_TAB_TYPE) => {
    setActiveTab(tab);
  };

  return (
    <div
      className={cn("slideRight", "deliveryReturn", "back", {
        back: activeTab === ACTIVE_TAB.RETURNS
      })}
    >
      <h3>
        {t("deliveryAndReturn")}
        <span
          className={cn({
            crossAgain: activeTab === ACTIVE_TAB.DELIVERY
          })}
          onClick={() => setModalState(false)}
        />
        {activeTab === ACTIVE_TAB.RETURNS && (
          <span
            className="crossBack "
            onClick={() => toggleTab(ACTIVE_TAB.DELIVERY)}
          />
        )}
      </h3>
      <div className="deliveryReturnTabs">
        <NavItem>
          <NavLink
            className={cn({ active: activeTab === ACTIVE_TAB.DELIVERY })}
            onClick={() => toggleTab(ACTIVE_TAB.DELIVERY)}
          >
            {t("delivery")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={cn({ active: activeTab === ACTIVE_TAB.RETURNS })}
            onClick={() => toggleTab(ACTIVE_TAB.RETURNS)}
          >
            {t("returns")}
          </NavLink>
        </NavItem>
      </div>
      <div className="deliveryReturnTabContent">
        <TabContent activeTab={activeTab}>
          <TabPane className="deliveryContent" tabId={ACTIVE_TAB.DELIVERY}>
            <ProductDeliveryInfo deliveryInfo={deliveryInfo} />
          </TabPane>
          <TabPane className="returnContent" tabId={ACTIVE_TAB.RETURNS}>
            <DeliveredTo cityLabel={cityLabel} />
            {returnsInfo &&
              returnsInfo.content.map(section => (
                <DynamicBannersWrapper section={section} key={section.id} />
              ))}
          </TabPane>
        </TabContent>
      </div>
    </div>
  );
};

export default DeliveryReturnMobileModal;
